import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const infernoData = LocalesData.inferno;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: infernoData.roleExperSubTitle,
  driverName: infernoData.driverName,
  driverType: infernoData.driverType,
  driversSex: infernoData.driversSex,
  driversBirthplace: infernoData.driversBirthplace,
  driversStructure: infernoData.driversStructure,
  driversRoleExperText: infernoData.driversRoleExperText,
  mechaInfoType: infernoData.mechaInfoType,
  mechaInfoNums: infernoData.mechaInfoNums,
  mechaInfoHeadHigh: infernoData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: infernoData.mechaInfoEmptyWeight,
  mechaInfoTotal: infernoData.mechaInfoTotal,
  mechaInfoStory: infernoData.mechaInfoStory,
  manufacturerGruopCh: infernoData.manufacturerGruopCh,
  cvCH: infernoData.cvCH,
  cvEN: infernoData.cvEN,
  cvJA: infernoData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512700596_1CN-Vox_Pilot_Get_Elite_Sailaja.wav',
      title: infernoData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512700596_2CN-Vox_Pilot_Entrance_Elite_Sailaja_a.wav',
      title: infernoData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512700596_3CN-Vox_Pilot_MVP_Elite_Sailaja_a.wav',
      title: infernoData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512731141_1EN-Vox_Pilot_Get_Elite_Sailaja.wav',
      title: infernoData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512731141_2EN-Vox_Pilot_Entrance_Elite_Sailaja_a.wav',
      title: infernoData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512731141_3EN-Vox_Pilot_MVP_Elite_Sailaja_a.wav',
      title: infernoData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512756474_1JP-Vox_Pilot_Get_Elite_Sailaja.wav',
      title: infernoData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512756474_2JP-Vox_Pilot_Entrance_Elite_Sailaja_a.wav',
      title: infernoData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/1762512756474_3JP-Vox_Pilot_MVP_Elite_Sailaja_a.wav',
      title: infernoData.voice.title3,
      isPlay: false
    }
  ]
};
